import { Reveal } from "./motion";

const CHAPTERS = [
  {
    no: "01",
    title: "Sorgfalt als Massstab",
    body: "Jedes Objekt beginnt mit einer präzisen Analyse. Wir definieren klare Standards, dokumentieren Ergebnisse und lassen nichts dem Zufall — Schweizer Gründlichkeit in jedem Detail.",
  },
  {
    no: "02",
    title: "Verlässlichkeit im Takt",
    body: "Termine sind Versprechen. Feste Ansprechpersonen, planbare Einsätze und flexible Zeitfenster — auch früh morgens, spät abends oder im laufenden Betrieb.",
  },
  {
    no: "03",
    title: "Verantwortung für Mensch & Umwelt",
    body: "Wir arbeiten mit umweltschonenden Verfahren, geschultem Personal und höchsten Sicherheitsstandards. Sauberkeit, die niemandem schadet.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifest" className="relative bg-[#111214] py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-16 flex items-center gap-4 lg:mb-24">
          <span className="h-px w-12 bg-[#4fd1c5]" />
          <span className="font-mono-spc text-[11px] uppercase tracking-[0.35em] text-[#4fd1c5]">Unser Prinzip</span>
        </div>

        <div className="grid gap-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24">
          <Reveal>
            <h2 className="font-head text-4xl font-light uppercase leading-[1.05] tracking-tighter text-metal sm:text-5xl lg:sticky lg:top-32 lg:text-6xl">
              Sauberkeit ist kein Ergebnis. Sie ist eine Haltung.
            </h2>
          </Reveal>

          <div className="flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-10 first:border-t-0 first:pt-0 sm:gap-10">
                  <span className="font-head text-5xl font-extralight text-[#4fd1c5]/60 sm:text-6xl">{c.no}</span>
                  <div>
                    <h3 className="mb-4 font-head text-2xl font-medium tracking-tight text-white">{c.title}</h3>
                    <p className="font-light leading-relaxed text-[#c0c5ce]/70">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
